var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16.8852,
    transform: "rotate(11.8818 20 20)",
    fill: "#6ABBBD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11122_180776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4356 18.9C18.1656 18.31 17.4356 17.7 17.4356 16.75C17.4356 15.66 18.4456 14.9 20.1356 14.9C21.9156 14.9 22.5756 15.75 22.6356 17H24.8456C24.7756 15.28 23.7256 13.7 21.6356 13.19V11H18.6356V13.16C16.6956 13.58 15.1356 14.84 15.1356 16.77C15.1356 19.08 17.0456 20.23 19.8356 20.9C22.3356 21.5 22.8356 22.38 22.8356 23.31C22.8356 24 22.3456 25.1 20.1356 25.1C18.0756 25.1 17.2656 24.18 17.1556 23H14.9556C15.0756 25.19 16.7156 26.42 18.6356 26.83V29H21.6356V26.85C23.5856 26.48 25.1356 25.35 25.1356 23.3C25.1356 20.46 22.7056 19.49 20.4356 18.9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11122_180776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(9 8.33203)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/DollarIcon.2339337b.svg";
export { ForwardRef as ReactComponent };